import { getActiveEventName } from '../Containers/Events/selectors';
import { selectActiveMomentId } from '../Containers/Moments/selectors';
import { useSelector } from 'react-redux';
// import React, { useState, useEffect } from 'react';
import { makeActiveChannelName } from '../Containers/Channels/channelsSelectors';

const useActiveInfo = () => {
    const eventId = useSelector((state: any) => state.ui.activeEvent);
    const channelName = useSelector(makeActiveChannelName);
    const eventName = useSelector(getActiveEventName);
    const momentId = useSelector(selectActiveMomentId);
    return {
        channelName,
        eventId,
        eventName,
        momentId,
    };
};
export default useActiveInfo;
